var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7691 0.266951C19.6565 0.143825 19.5142 0.0585764 19.359 0.0212298C19.2038 -0.0161169 19.0422 -0.00400938 18.893 0.0561287L0.538418 7.38908C0.380125 7.45505 0.243843 7.57236 0.147674 7.72544C0.0515052 7.87852 0 8.06012 0 8.24612C0 8.43213 0.0515052 8.61373 0.147674 8.76681C0.243843 8.91988 0.380125 9.0372 0.538418 9.10316L7.70507 12.2472L12.9945 6.41747L14.1709 7.7099L8.8564 13.5488L11.7264 21.4225C11.7882 21.5931 11.8952 21.7393 12.0336 21.8423C12.1719 21.9452 12.3352 22.0002 12.5023 22C12.6709 21.9962 12.8345 21.9364 12.9715 21.8284C13.1085 21.7204 13.2126 21.5693 13.2699 21.395L19.9443 1.2294C20.0011 1.06723 20.0148 0.890647 19.9838 0.720241C19.9528 0.549835 19.8783 0.392629 19.7691 0.266951Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMsgIcon);
export default __webpack_public_path__ + "static/media/sendMsgIcon.1eaec57401bd56246e744237f37514ac.svg";
export { ForwardRef as ReactComponent };